import { Menu, useVideoQualityOptions } from '@vidstack/react';
// See "Icons" component page for setup before importing the following:
import { CheckIcon, SettingsMenuIcon } from '@vidstack/react/icons';
import { SubmenuButton } from "@/components/player/layouts/shared/menus/submenu-button";
export function QualitySubmenu() {
  const options = useVideoQualityOptions(),
    currentQuality = options.selectedQuality?.height,
    hint = options.selectedValue !== 'auto' && currentQuality ? `${currentQuality}p` : `Auto${currentQuality ? ` (${currentQuality}p)` : ''}`;
  return <Menu.Root className="vds-menu" data-sentry-element="unknown" data-sentry-component="QualitySubmenu" data-sentry-source-file="quality-menu.tsx">
            <SubmenuButton label="Quality" hint={hint} disabled={options.disabled} icon={SettingsMenuIcon} data-sentry-element="SubmenuButton" data-sentry-source-file="quality-menu.tsx" />
            <Menu.Content className="vds-menu-items" data-sentry-element="unknown" data-sentry-source-file="quality-menu.tsx">
                <Menu.RadioGroup className="vds-radio-group" value={options.selectedValue} data-sentry-element="unknown" data-sentry-source-file="quality-menu.tsx">
                    {options.map(({
          label,
          value,
          bitrateText,
          select
        }) => <Menu.Radio className="vds-radio" value={value} onSelect={select} key={value}>
                            <CheckIcon className="vds-icon" />
                            <span className="vds-radio-label">{label}</span>
                            {bitrateText ? <span className="vds-radio-hint">{bitrateText}</span> : null}
                        </Menu.Radio>)}
                </Menu.RadioGroup>
            </Menu.Content>
        </Menu.Root>;
}